import React from 'react'
import { Box } from '@mui/material'

import ClientHeader from '../../../components/ClientHeader/ClientHeader'
import DetailStatusMobileHeader from '../../../components/DetailStatusMobileHeader'
import DetailsSummarySection from '../../../components/details/summary/DetailsSummarySection'
import FormHeaderDetailActions from '../../../components/action_button/FormHeaderDetailActions'
import { POS_TASK_HEADER_CONFIG } from '../shared/posDetailsConstants'

export default function PosDetailsMobile({
  headerData,
  summaryFields,
  scopeFields,
  assignmentFields,
  assignmentEmptyContent,
  extraTitle,
  extraFields,
  extraContent,
  statusUI,
  activity,
  showActions,
  suspending,
  onSuspend,
  onClone
}) {
  return (
    <div className="container-fluid px-0">
      <DetailStatusMobileHeader
        title="Detalles de tarea en punto de venta:"
        statusUI={statusUI}
        fallbackStatus={activity?.status}
        showStatus={false}
      />

      {showActions && (
        <Box sx={{ mb: 2, px: { xs: 1.25, sm: 0 } }}>
          <FormHeaderDetailActions
            secondaryLabel="Suspender tarea"
            onSecondary={onSuspend}
            showSecondary={!activity.suspended}
            primaryLabel="Crear copia de tarea"
            onPrimary={onClone}
            disabled={suspending}
            className="pos-details-mobile-actions"
          />
        </Box>
      )}

      <ClientHeader data={headerData} config={POS_TASK_HEADER_CONFIG} cardSx={{ p: 2, mb: 2 }} />

      <DetailsSummarySection
        summaryFields={summaryFields}
        scopeFields={scopeFields}
        assignmentFields={assignmentFields}
        assignmentEmptyContent={assignmentEmptyContent}
        extraFields={extraFields}
        extraContent={extraContent}
        summaryTitle="DETALLES DE LA TAREA"
        scopeTitle="CLIENTES Y ATRIBUTOS"
        assignmentTitle="TAREA ASIGNADA A"
        extraTitle={extraTitle}
        secondarySectionsType="title"
        summaryOpenLabel="Abrir detalles de la tarea"
        summaryCloseLabel="Cerrar detalles de la tarea"
        scopeOpenLabel="Abrir clientes y atributos"
        scopeCloseLabel="Cerrar clientes y atributos"
        assignmentOpenLabel="Abrir tarea asignada a"
        assignmentCloseLabel="Cerrar tarea asignada a"
        extraOpenLabel="Abrir datos específicos de la tarea"
        extraCloseLabel="Cerrar datos específicos de la tarea"
      />
    </div>
  )
}
